import * as Sentry from '@sentry/vue';
export const handleLogSentry = (propertyInfo: any) => {
  Sentry.setUser({
      username: propertyInfo.ContactName,
      email: propertyInfo.ContactEmail,
      customerName: propertyInfo.CustomerName,
      env: "Production"
  });
}